export const CATEGORY_LIST_ACTION = "CATEGORY_LIST_ACTION";
export const CATEGORY_LIST_SUCCESS = "CATEGORY_LIST_SUCCESS";
export const CATEGORY_LIST_ALL_ACTION = "CATEGORY_LIST_ALL_ACTION";
export const CATEGORY_LIST_ALL_SUCCESS = "CATEGORY_LIST_ALL_SUCCESS";
export const CATEGORY_LIST_FAIL = "CATEGORY_LIST_FAIL";
export const CATEGORY_DETAIL_ACTION = "CATEGORY_DETAIL_ACTION";
export const CATEGORY_DETAIL_SUCCESS = "CATEGORY_DETAIL_SUCCESS";
export const CATEGORY_DETAIL_FAIL = "CATEGORY_DETAIL_FAIL";
export const CATEGORY_FAIL = "CATEGORY_FAIL";
export const CATEGORY_DETAIL_UPDATE_ACTION = "CATEGORY_DETAIL_UPDATE_ACTION";
export const CATEGORY_DETAIL_CREATE_ACTION = "CATEGORY_DETAIL_CREATE_ACTION";
export const CATEGORY_DETAIL_DELETE_ACTION = "CATEGORY_DETAIL_DELETE_ACTION";

export const CATEGORY_CREATE_TRANSLATE_ACTION = "CATEGORY_CREATE_TRANSLATE_ACTION";
export const CATEGORY_CREATE_TRANSLATE_SUCCESS = "CATEGORY_CREATE_TRANSLATE_SUCCESS";

export const CATEGORY_UPDATE_TRANSLATE_ACTION = "CATEGORY_UPDATE_TRANSLATE_ACTION";
export const CATEGORY_UPDATE_TRANSLATE_SUCCESS = "CATEGORY_UPDATE_TRANSLATE_SUCCESS";

export const CATEGORY_DELETE_TRANSLATE_ACTION = "CATEGORY_DELETE_TRANSLATE_ACTION";
export const CATEGORY_DELETE_TRANSLATE_SUCCESS = "CATEGORY_DELETE_TRANSLATE_SUCCESS";
